<template>
    <div>
        <a href="/booking/paystack/pay" class="button btn btn--tertiary">
            Pay Now
        </a>
    </div>
</template>

<script>
export default {
    data: () => ({}),
    mounted() {},
    methods: {},
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Gateway/PayStack.vue